import type CK from '~/types/contentking';

import {
	useAccountIsManagedQuery,
} from './useAccountIsManaged.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountIsManaged(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountIsManagedQuery,
		accountId,
	);

	return data?.account?.isManaged ?? null;
}



export default useAccountIsManaged;
